import {useEffect, useMemo} from "react";

import {useMap} from "react-leaflet";


import {LeafletEvent, LeafletMouseEvent} from "leaflet";
import {SetStatePropsType} from "@baseTypes/base";
import {SearchLocationEvent} from "@ui/leafletCustom/types/search";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {useLeafletMapEvents} from "@ui/leafletCustom/hooks/useLeafletMapEvents";


export function useAddHandlersAddPointMutateSingleVoyage({
                                                             setLatLng,
                                                             setOpenPopoverAction,
                                                             setPositionPopoverAction,
                                                             setActivePointHelperIndicator,
                                                         }: {
    setLatLng: SetStatePropsType<{ lat: number, lng: number } | null>,
    setOpenPopoverAction: SetStatePropsType<boolean>,
    setActivePointHelperIndicator: SetStatePropsType<boolean>,
    setPositionPopoverAction: SetStatePropsType<{ top: number, left: number }>

}) {

    const {
        setShowAddPointIcon,
    } = useRootContextMutateSingleVoyage()

    const map = useMap()

    useEffect(() => {
        function searchEventHandler({location}: {
            location: SearchLocationEvent
        }) {
            setShowAddPointIcon(true)
            setLatLng({
                lat: Number(location.raw.lat),
                lng: Number(location.raw.lon),
            })

        }

        map.on('geosearch/showlocation', searchEventHandler as any);
        return () => map.off('geosearch/showlocation', searchEventHandler as any) as any;
    }, []);

    useLeafletMapEvents({
        contextmenu(event) {
            setShowAddPointIcon(true)
            setOpenPopoverAction(true)
            setPositionPopoverAction({
                left: event.originalEvent.clientX,
                top: event.originalEvent.clientY
            })
            setActivePointHelperIndicator(true)
            const {lat, lng} = event.latlng;
            setLatLng({
                lat,
                lng,
            })

        },
    })

    const markerEventHandlers = useMemo(() => ({
        dragend(e: LeafletEvent) {
            const latLng = e.target.getLatLng()
            setLatLng({
                lat: latLng?.lat,
                lng: latLng?.lng
            })

        },
        click(e: LeafletMouseEvent) {
            setShowAddPointIcon(true)
            setOpenPopoverAction(true)
            setPositionPopoverAction({
                left: e.originalEvent.clientX,
                top: e.originalEvent.clientY
            })
            setActivePointHelperIndicator(true)
            const latLng = e.target.getLatLng()
            setLatLng({
                lat: latLng?.lat,
                lng: latLng?.lng
            })
        }
    }), [])

    return {
        markerEventHandlers
    }
}